import React from 'react';
import cx from 'classnames';
import * as Icon from 'react-feather';
import { useTranslation } from 'react-i18next';

import styles from '../BookSearch.module.scss';

const BookRecommendationItem = ({ book, variant = 'card', onAddBook }) => {
    const { t } = useTranslation();
    const isResult = variant === 'result';

    return (
        <div className={cx(styles.recommendationBook, isResult && styles.recommendationBookResult)}>
            <img src={book.coverUrl} alt={book.title} className={styles.recommendationBookCover} />
            <div className={styles.recommendationBookMeta}>
                <h3 className={styles.recommendationBookTitle}>{book.title}</h3>
                {book.author && <p className={styles.recommendationBookAuthor}>{book.author}</p>}
                <button type="button" className={styles.recommendationAddButton} onClick={() => onAddBook(book)}>
                    {t('add_book')}
                </button>
            </div>
            {isResult && book && book.publisher &&
                <div className={styles.recommendationSchemeTag}>
                    <span>{book.publisher.name}</span>
                </div>
            }
        </div>
    )
}

export default BookRecommendationItem;
